export const exceptPercentageAndBrackets = /^[^%|<>]+$/;
export const merchantIdMatcher = /\/[a-z-]+\/m\/([0-9A-HJKMNP-TV-Z]{13})(?:$|\/|\?)/i;
